import Vue from 'vue';

export async function index(params) {
  const response = await Vue.prototype.$http.post('/products', params);

  return response.data;
}

export async function changeLocalCategory(product_id, local_category) {
  const response = await Vue.prototype.$http.put(`products/${product_id}/local_category`, { local_category });
  
  return response.data;
}

export async function showPricesByEan(barcode) {
  const response = await Vue.prototype.$http.get(`products_prices/ean/${barcode}`);

  return response.data;
}